module.exports = __webpack_public_path__ + "img/hover_icon_manejo_Practicantes.d1f8dede.svg";